var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, List, Stack } from "@mui/material";
import { COLORS } from "../../../../../constants";
import { Text } from "../../../../Atoms";
import MenuItem from "../MenuItem";
import { useRef, useState } from "react";
var MenuSection = function (_a) {
    var _b;
    var section = _a.section, activeNav = _a.activeNav, activeColor = _a.activeColor, handleClick = _a.handleClick, offSet = _a.offSet, sectionsLength = _a.sectionsLength;
    var listRef = useRef(null);
    var _c = __read(useState({ height: 40, top: 0 }), 2), indicatorData = _c[0], setIndicatorData = _c[1];
    var onClick = function () {
        handleClick(section.menuItems[0].id);
    };
    // use default values if not currently in this section to preserve animation
    // this is also to hide the bar when in a different section
    var indicatorTop = offSet > activeNav.idx
        ? -40
        : activeNav.idx > sectionsLength + offSet
            ? (_b = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight
            : indicatorData.top;
    var indicatorHeight = offSet > activeNav.idx ? 40 : indicatorData.height;
    return (_jsxs(Stack, __assign({ mt: 7, sx: {
            ":first-of-type": {
                mt: 0,
            },
        } }, { children: [_jsx(Text, __assign({ sx: { cursor: "pointer" }, onClick: onClick, variant: "subtitle2" }, { children: section.title })), _jsxs(List, __assign({ sx: { mt: 3.5, py: 0, position: "relative" }, ref: listRef }, { children: [_jsx(Box, __assign({ position: "absolute", top: 0, left: -16, width: 2, overflow: "hidden", height: "100%", bgcolor: COLORS.P_OUTLINE, mr: 2 }, { children: _jsx(Box, { position: "absolute", left: 0, width: 2, height: indicatorHeight, bgcolor: activeColor, sx: {
                                transform: "translateY(".concat(indicatorTop, "px)"),
                                transition: "0.3s linear all",
                            } }) })), section.menuItems.map(function (itm) { return (_jsx(MenuItem, { active: activeNav.id === itm.id, activeColor: activeColor, setIndicatorData: setIndicatorData, menuItem: itm, handleClick: handleClick }, itm.id)); })] }))] })));
};
export default MenuSection;
